import React, { useState } from "react";
import axios from "axios";
import { baseUrl } from "../config";
import styled from "styled-components";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      await axios.post(baseUrl + "/forgot-password", { email });
      setMessage("Si ce compte existe, un email de réinitialisation a été envoyé.");
    } catch (err) {
      setError("Erreur lors de la demande. Veuillez réessayer.");
    }
  };

  return (
    <FormContainer>
      <h2>Réinitialiser le mot de passe</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Email:
          <input
            type="text"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <button type="submit">Envoyer</button>
      </form>
      {message && <p>{message}</p>}
      {error && <ErrorText>{error}</ErrorText>}
    </FormContainer>
  );
};

const FormContainer = styled.div`
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface-2);

  h2 {
    margin-bottom: 20px;
  }

  label {
    display: block;
    margin-bottom: 10px;

    input {
      width: 100%;
      padding: 8px;
      margin-top: 5px;
    }
  }

  button {
    margin-top: 20px;
    padding: 10px 20px;
    background-color: ${(props) => props.buttonColor || "var(--accent)"};
    color: #13110e;
    border: 1px solid var(--accent);
    border-radius: var(--radius-md);
    cursor: pointer;

    &:hover {
      background-color: var(--accent-hover);
      border-color: var(--accent-hover);
      box-shadow: 0 0 0 3px var(--accent-bg);
    }
  }

  p {
    margin-top: 10px;
    color: red;
  }
`;

const ErrorText = styled.p`
  margin-top: 10px;
  color: red;
`;
export default ForgotPassword;
